import styled from "styled-components";

import DeleteButton from "components/buttons/DeleteButton";

const DeleteRowButton = styled(DeleteButton)`
  vertical-align: middle;
  margin-left: 1px;
  height: 1.02em;
`;

export default DeleteRowButton;
